/**
 * Create an empty Team object
 *
 * @returns {Object} A default Team object
 */
function defaultTeam() {
  return {
    id: '',
    name: '',
    city: '',
    country: '',
    player_kit: null,
    goalkeeper_kit: null,
  };
}

/**
 * Create a default Venue object
 *
 * @returns {Object} A default Venue object
 */
function defaultVenue() {
  return {
    id: '',
    name: '',
    field_length: 105,
    field_width: 68,
  };
}

/**
 * Create an empty Match object
 *
 * @returns {Object} A default Match object
 */
function defaultMatch() {
  return {
    team_a: defaultTeam(),
    team_b: defaultTeam(),
    referee_kit: '',
    venue: defaultVenue(),
    date: new Date(),
  };
}

/**
 * Create a default project Options object
 *
 * @returns {Object} A default Options object
 */
function defaultOptions() {
  return {
    min_track_length: 25,
    sort_max_age: 25,
  };
}

/**
 * Create a default Project object
 *
 * @returns {Object} A default Project object
 */
function defaultProject() {
  return {
    id: '',
    name: '',
    created_at: null,
    updated_at: null,
    status: 0,
    match: defaultMatch(),
    options: defaultOptions(),
    video: []
  };
}

/**
 * Create a wrapper for a video
 *
 * @returns {Object} An object representing video
 */
function defaultVideo() {
  return {
    id: '',
    name: '',
    size: -1,
    url: null,
    frame_start: 0,
    frame_end: -1,
  };
}

export default {
  defaultProject,
  defaultTeam,
  defaultVenue,
  defaultMatch,
  defaultVideo,
  defaultOptions,
};
